import {
  AfterViewInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from "@angular/core";
import { ActivatedRoute, RouterLinkActive, Routes } from "@angular/router";
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";
import { NgcCookieConsentService } from "ngx-cookieconsent";

import { Cookie } from "../../models/cookie";
import { AuthService } from "../../auth-n-routing/auth-service.service";
import { RefillsHandlerService } from "../../api-handlers/refills-handler.service";
import { TravelsHandlerService } from "../../api-handlers/travels-handler.service";
import { environment } from "../../../environments/environment";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  animations: [
    trigger("fade", [
      state("void", style({ opacity: 0 })),
      transition(":enter, :leave", [animate(500)]),
    ]),
  ],
})
export class DashboardComponent implements AfterViewInit, OnInit {
  isViewInitialized = false;
  navLinks = [];
  currentRoute: string;
  rulesAccepted: boolean = false;

  shouldRenderAvailableVehicles = false;

  constructor(
    private ccService: NgcCookieConsentService, //! NON DA TOCCARE STA RIGA, TRANNE SE È DESIDERATO A STACCARE L'AVVISO DEI COOKIE
    public refillsHandlerService: RefillsHandlerService,
    public travelsHandlerService: TravelsHandlerService,
    public authService: AuthService,
    private changeDetector: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.navLinks =
      this.route.routeConfig && this.route.routeConfig.children
        ? this.buildNavItems(this.route.routeConfig.children)
        : [];

    const areCookiesEmpty = !document.cookie.includes('privacy-rules');
    const expireDate: string = this.getCookieExpireDate();

    if (areCookiesEmpty) {
      document.cookie = `privacy-rules=${JSON.stringify(
        environment.cookie
      )}; expires=${expireDate}; path=/`;
    } else {
      const privacyRules: Cookie = this.getCookiesObject();

      if (environment.cookie.version === privacyRules.version) {
        this.rulesAccepted = privacyRules.rules;
      } else {
        document.cookie = `privacy-rules=${JSON.stringify(
          environment.cookie
        )}; expires=${expireDate}; path=/`;
      }
    }
  }

  ngAfterViewInit() {
    this.isViewInitialized = true;
    this.changeDetector.detectChanges();
  }

  getCookiesObject(): Cookie {
    if (!document.cookie.includes("cookieconsent_status")) {
      const cookieStr = document.cookie.substring("privacy-rules=".length);
      return JSON.parse(cookieStr);
    } else {
      const cookieArray = document.cookie.split("; ");
      let privacyRulesJson = "";

      cookieArray.forEach((cookie) => {
        const [name, value] = cookie.split("=");

        if (name === "privacy-rules") {
          privacyRulesJson = decodeURIComponent(value);
        }
      });

      return JSON.parse(privacyRulesJson);
    }
  }

  getCookieExpireDate(): string {
    const days = 365;
    const expireDate = new Date();
    expireDate.setTime(expireDate.getTime() + days * 24 * 60 * 60 * 1000);
    return expireDate.toUTCString();
  }

  onRulesAccept() {
    const privacyRules: Cookie = this.getCookiesObject();
    privacyRules.rules = true;

    document.cookie = `privacy-rules=${JSON.stringify(
      privacyRules
    )}; expires=${this.getCookieExpireDate()}; path=/`;

    this.rulesAccepted = true;
  }

  buildNavItems(routes: Routes) {
    const isUser = this.authService.is_authenticated();
    const isAdmin = this.authService.is_admin();
    const isSuperAdmin = this.authService.is_superadmin();

    let structuredRoutes = routes
      .filter((route) => route.data)
      .map(({ path = "", data }) => {
        if (isSuperAdmin) {
          return {
            path: path,
            label: data.label,
            icon: data.icon,
          };
        } else {
          if (isAdmin && data.role !== "superadmin") {
            return {
              path: path,
              label: data.label,
              icon: data.icon,
            };
          } else {
            if (isUser && data.role !== "admin" && data.role !== "superadmin") {
              return {
                path: path,
                label: data.label,
                icon: data.icon,
              };
            }
          }
        }
      });

    structuredRoutes = structuredRoutes.filter((route) => {
      return route !== undefined;
    });

    return structuredRoutes;
  }

  isLinkActive = (rla: RouterLinkActive): boolean => rla.isActive;
}
